import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["reviewAppId", "submitButton"]

  connect() {
    this.setupValidation()
    this.validateInput() // Initial validation
  }

  setupValidation() {
    this.reviewAppIdTarget.addEventListener("input", () => {
      this.validateInput()
    })
  }

  validateInput() {
    const value = this.reviewAppIdTarget.value.trim()
    const isEmpty = value === ""
    
    if (isEmpty) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("disabled")
    } else {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove("disabled")
    }
  }
}
